import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadPacman = () => {
    const promisePacman = new Promise((resolve, reject) => {
        loader.load(
            "office/model/pacman/pacman.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(-2.7515737136809157, 2.7359995996837263, 9.899584556085877);
                model.scale.set(0.16, 0.16, 0.16);
                model.rotation.set(3.141592653589793, -0.02793671950825484, 3.141592653589793);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promisePacman;
};

export { loadPacman };
